import axios from 'axios';
import { toast } from 'react-toastify';

// Add a request interceptor
axios.interceptors.request.use(
  async config => {
    if (config.url.includes('user/') || config.url.includes('admin/')) {
      const token = localStorage.getItem('token');
      if (token !== null) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        toast.error('Acesse sua conta para realizar esta ação!');
        return Promise.reject({
          response: { data: 'Usuário não autenticado', status: '' },
        });
      }
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    //caso de erro de autenticação, seja pelo token ter expirado ou outro motivo
    //Redireciona usuário de volta para home, porém sem autenticação
    if (error.response.status === 401 || error.response.status === 403) {
      toast.error('Por favor, realize o login novamente!');
      setTimeout(() => {
        window.location.href = '/logout';
      }, 1000);
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);
